import BaseModelAPI from '../BaseModelAPI';

export default class RoleManagementList extends BaseModelAPI {

	static entity = 'rolemanagementlist'
	static entityName = 'rolemanagement';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
